import { Chip, styled } from "@mui/material";

export const StatusChip = styled(Chip)<{ variant?: "dark" | "filled" }>(
  ({ theme }) => ({
    color: theme.palette.common.white,
    padding: theme.spacing(0, 0.5),
    fontWeight: theme.typography.fontWeightMedium,
    "& .MuiChip-icon": {
      fontSize: theme.iconSize.xs,
      marginRight: theme.spacing(0.125),
    },
  }),
);
